export { default } from './VitalSignCard';
